import { render, staticRenderFns } from "./ReportProjectDetails.vue?vue&type=template&id=5dc92c3d"
import script from "./ReportProjectDetails.vue?vue&type=script&lang=js"
export * from "./ReportProjectDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports